import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/Button";
import { THEMES, useThemeCntx } from "@/context/ThemeContext";
import { Moon, Sun } from "lucide-react";
const themeToggleContent = {
  [THEMES.light]: "Switch to dark mode",
  [THEMES.dark]: "Switch to light mode"
};
interface ThemeToggleProps {
  className?: string;
}
export const ThemeToggle = t0 => {
  const $ = _c(10);
  const {
    className
  } = t0;
  const {
    theme,
    mounted,
    updateTheme
  } = useThemeCntx();
  const Icon = theme === THEMES.dark ? Sun : Moon;
  let t1;
  if ($[0] !== theme || $[1] !== updateTheme) {
    t1 = () => {
      const newTheme = theme === THEMES.light ? THEMES.dark : THEMES.light;
      updateTheme(newTheme);
    };
    $[0] = theme;
    $[1] = updateTheme;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleToggle = t1;
  if (!mounted) {
    return null;
  }
  let t2;
  if ($[3] !== Icon) {
    t2 = <Icon className="size-4" />;
    $[3] = Icon;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = themeToggleContent[theme];
  let t4;
  if ($[5] !== className || $[6] !== handleToggle || $[7] !== t2 || $[8] !== t3) {
    t4 = <Button onClick={handleToggle} variant="secondary" icon={t2} iconPosition="right" isIcon={true} className={className} aria-label={t3} data-testid="theme-toggle-button" />;
    $[5] = className;
    $[6] = handleToggle;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};